// initialed state
export const initialState = () => ({});

const state = initialState();

export default state;
